import { render, staticRenderFns } from "./ChooseOneAction.vue?vue&type=template&id=b19958c2&scoped=true"
import script from "./ChooseOneAction.vue?vue&type=script&lang=ts"
export * from "./ChooseOneAction.vue?vue&type=script&lang=ts"
import style0 from "./ChooseOneAction.vue?vue&type=style&index=0&id=b19958c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19958c2",
  null
  
)

export default component.exports